export default "__VITE_ASSET__377922f0__"